document.addEventListener('click', (e) => {
    // Add class ac-body and hidden to dropdowns
    const accordionBodies = document.querySelectorAll('.ac-body')
    accordionBodies.forEach(function (accordionBody) {
        const accordionHeader = accordionBody.previousElementSibling

        if (e.target !== accordionBody && e.target !== accordionHeader && !accordionBody.contains(e.target)) {
            accordionHeader.classList.toggle('active')
            accordionBody.classList.toggle('!block')
        }
    })

    // Add class ac-header to the button that opens the dropdown
    if (e.target.closest('.ac-header')) {
        const accordionBody = e.target.closest('.ac-header').nextElementSibling
        const accordionHeader = e.target.closest('.ac-header')
        accordionHeader.classList.toggle('active')
        accordionBody.classList.toggle('!block')
    }
    if (e.target.closest('.ac-footer')) {
        const accordionBody = e.target.closest('.ac-footer').previousElementSibling
        const accordionHeader = e.target.closest('.ac-footer')
        accordionHeader.classList.toggle('active')
        accordionBody.classList.toggle('!block')
    }

    if (e.target.classList.contains('ac-open-top')) {
        const accordionBody = e.target.nextElementSibling
        const accordionHeader = e.target
        accordionHeader.classList.toggle('active')

        if (!accordionBody.classList.contains('!flex')) {
            accordionBody.classList.add('!flex', 'gap-3', 'bottom-full', 'p-1', 'bg-white', 'rounded')
        } else {
            accordionBody.classList.remove('!flex', 'gap-3', 'bottom-full', 'p-1', 'bg-white', 'rounded')
        }
    }

    if (e.target.classList.contains('ac-open-bottom')) {
        const accordionBody = e.target.nextElementSibling
        const accordionHeader = e.target
        accordionHeader.classList.toggle('active')

        if (!accordionBody.classList.contains('!flex')) {
            accordionBody.classList.add('!flex', 'gap-3', 'top-full', 'p-1', 'bg-white', 'rounded')
        } else {
            accordionBody.classList.remove('!flex', 'gap-3', 'top-full', 'p-1', 'bg-white', 'rounded')
        }
    }

    if (e.target.classList.contains('overlay')) {
        const overlay = e.target
        overlay.classList.remove('visible')
    }
})

// Lyssna på document click
// document.addEventListener('click', (event) => {
//     const summary = event.target.closest('summary') // Kolla om klicket var på <summary>
//     if (!summary) return // Om klicket inte var på <summary>, gör ingenting

//     const details = summary.parentElement // Hämta <details>-elementet
//     const content = details.querySelector('summary ~ *')

//     if (!details.hasAttribute('open')) {
//         // Öppna det klickade details-elementet
//         animateDetails(content, true, () => {
//             details.open = true // Tillåt öppning efter animation
//         })
//     } else {
//         // Förhindra omedelbar stängning
//         event.preventDefault()
//         animateDetails(content, false, () => {
//             details.open = false // Stäng efter animation
//         })
//     }
// })

// // Funktion för att animera öppning/stängning
// function animateDetails(content, opening, callback) {
//     if (opening) {
//         content.style.overflow = 'hidden' // Förhindra innehåll från att flöda ut
//         const animation = content.animate(
//             [
//                 { height: '0px', opacity: 0 },
//                 { height: content.scrollHeight + 'px', opacity: 1 },
//             ],
//             { duration: 300, easing: 'ease-out' }
//         )
//         animation.onfinish = () => {
//             content.style.height = 'auto' // Sätt slutgiltig höjd
//             content.style.overflow = '' // Återställ overflow
//             callback()
//         }
//     } else {
//         content.style.overflow = 'hidden'
//         const animation = content.animate(
//             [
//                 { height: content.scrollHeight + 'px', opacity: 1 },
//                 { height: '0px', opacity: 0 },
//             ],
//             { duration: 300, easing: 'ease-in' }
//         )
//         animation.onfinish = () => {
//             content.style.height = '0px' // Sätt slutgiltig höjd
//             content.style.overflow = '' // Återställ overflow
//             callback()
//         }
//     }
// }
